var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.707 140C133.153 140 140 110.451 140 74C140 37.5492 133.153 8 124.707 8C116.261 8 109.414 37.5492 109.414 74C109.414 110.451 116.261 140 124.707 140Z",
    fill: "url(#paint0_linear_894_46040)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1558 38.7329C49.8795 38.7329 51.2769 37.3503 51.2769 35.6448C51.2769 33.9393 49.8795 32.5566 48.1558 32.5566C46.432 32.5566 45.0347 33.9393 45.0347 35.6448C45.0347 37.3503 46.432 38.7329 48.1558 38.7329Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5451 59.4658C40.4532 59.4658 41.1893 58.7375 41.1893 57.839C41.1893 56.9405 40.4532 56.2122 39.5451 56.2122C38.637 56.2122 37.9009 56.9405 37.9009 57.839C37.9009 58.7375 38.637 59.4658 39.5451 59.4658Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8631 61.3975C13.4117 61.3975 13.8565 60.9574 13.8565 60.4146C13.8565 59.8717 13.4117 59.4316 12.8631 59.4316C12.3144 59.4316 11.8696 59.8717 11.8696 60.4146C11.8696 60.9574 12.3144 61.3975 12.8631 61.3975Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8548 60.478C97.4721 60.478 98.7832 59.1807 98.7832 57.5804C98.7832 55.9801 97.4721 54.6829 95.8548 54.6829C94.2374 54.6829 92.9263 55.9801 92.9263 57.5804C92.9263 59.1807 94.2374 60.478 95.8548 60.478Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1167 45.6063L83.4897 43.9966L81.8628 45.6063L83.4897 47.2161L85.1167 45.6063Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4839 21.7819L13.8569 20.1721L12.23 21.7819L13.8569 23.3916L15.4839 21.7819Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1025 34.7222L28.9327 37.3679C28.6585 37.7023 28.6585 38.1811 28.9327 38.5155L31.1025 41.1612L28.4285 39.0143C28.0905 38.743 27.6067 38.743 27.2687 39.0143L24.5947 41.1612L26.7645 38.5155C27.0387 38.1811 27.0387 37.7023 26.7645 37.3679L24.5947 34.7222L27.2687 36.869C27.6067 37.1404 28.0905 37.1404 28.4285 36.869L31.1025 34.7222Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5121 37.9416L28.3041 38.3923L27.8486 47.5031L27.393 38.3923L18.1851 37.9416L27.393 37.4909L27.8486 28.3801L28.3041 37.4909L37.5121 37.9416Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3936 131.396L14.1516 132.91C13.9946 133.102 13.9946 133.376 14.1516 133.567L15.3936 135.082L13.863 133.853C13.6695 133.698 13.3925 133.698 13.1991 133.853L11.6685 135.082L12.9105 133.567C13.0675 133.376 13.0675 133.102 12.9105 132.91L11.6685 131.396L13.1991 132.625C13.3925 132.78 13.6695 132.78 13.863 132.625L15.3936 131.396Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0632 133.239L13.7923 133.497L13.5316 138.712L13.2708 133.497L8 133.239L13.2708 132.981L13.5316 127.766L13.7923 132.981L19.0632 133.239Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0089 25.8766L91.7056 22.6082L88.4022 25.8767L91.7056 29.1451L95.0089 25.8766Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7052 9.54712L92.2444 23.1416H91.166L91.7052 9.54712Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7052 42.1267L92.2444 28.5322H91.166L91.7052 42.1267Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M108.169 25.837L94.4297 25.3035V26.3705L108.169 25.837Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2422 25.837L88.9818 25.3035V26.3705L75.2422 25.837Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_894_46040",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 8,
    width: 125,
    height: 132
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M124.213 8C119.403 8 115.096 16.9962 112.2 31.1805H15.1587V128.41H115.276C117.817 135.718 120.895 140 124.213 140C132.932 140 140 110.451 140 74C140 37.5492 132.932 8 124.213 8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_894_46040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.7378 112.956L54.1514 120.683L37.5566 74L87.3409 83.3366L84.7378 112.956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3317 85.2844C89.3317 85.2844 89.9082 75.4332 81.1232 69.1649C74.5866 64.5009 77.3551 38.1963 72.5677 34.5366C67.7802 30.8768 59.4619 34.2289 57.6455 45.3537C56.341 53.3432 63.0921 66.4511 60.9432 68.7418C58.7942 71.0326 40.267 68.0757 31.598 70.2883C23.7948 72.2799 19.0001 86.0523 33.006 89.198C47.0119 92.3436 57.3514 91.3732 58.3268 85.3282C59.5449 77.7784 47.4597 77.0558 40.2766 77.3206",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3317 85.2844C89.3317 85.2844 89.9082 75.4332 81.1232 69.1649C74.5866 64.5009 77.3551 38.1963 72.5677 34.5366C67.7802 30.8768 59.4619 34.2289 57.6455 45.3537C56.341 53.3432 63.0921 66.4511 60.9432 68.7418C58.7942 71.0326 40.267 68.0757 31.598 70.2883C23.7948 72.2799 19.0001 86.0523 33.006 89.198C47.0119 92.3436 57.3514 91.3732 58.3268 85.3282C59.5449 77.7784 47.4597 77.0558 40.2766 77.3206",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5597 86.0493C22.1018 88.621 20.336 95.076 26.0636 99.1372C34.7766 105.315 56.3745 106.465 59.3714 96.2185C60.3875 92.7446 58.854 90.5658 56.0561 88.8358",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5597 86.0493C22.1018 88.621 20.336 95.076 26.0636 99.1372C34.7766 105.315 56.3745 106.465 59.3714 96.2185C60.3875 92.7446 58.854 90.5658 56.0561 88.8358",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5227 110.477C27.5227 110.477 23.1221 118.338 33.9792 121.48C44.8876 124.637 51.5251 122.409 53.6136 119.94C55.5907 117.603 55.2261 114.222 52.8752 112.683",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5227 110.477C27.5227 110.477 23.1221 118.338 33.9792 121.48C44.8876 124.637 51.5251 122.409 53.6136 119.94C55.5907 117.603 55.2261 114.222 52.8752 112.683",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6778 99.8147C22.752 102.56 25.0848 109.126 28.1161 110.58C36.3107 114.511 50.5378 116.553 56.7688 109.79C58.9654 107.405 59.1354 102.177 56.6055 100.754",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6778 99.8147C22.752 102.56 25.0848 109.126 28.1161 110.58C36.3107 114.511 50.5378 116.553 56.7688 109.79C58.9654 107.405 59.1354 102.177 56.6055 100.754",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9292 120.548C52.9292 120.548 60.1935 122.112 68.1166 121.513C77.4704 120.806 86.4764 114.237 87.9966 110.797",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9292 120.548C52.9292 120.548 60.1935 122.112 68.1166 121.513C77.4704 120.806 86.4764 114.237 87.9966 110.797",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8546 77.2589C87.8546 77.2589 89.5107 72.8904 93.1924 74.9621C96.9872 77.0974 97.7656 86.8109 97.3485 94.5267C96.9662 101.6 94.9367 115.033 90.2835 116.722C86.0065 118.273 84.5044 115.126 84.5044 115.126",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8546 77.2589C87.8546 77.2589 89.5107 72.8904 93.1924 74.9621C96.9872 77.0974 97.7656 86.8109 97.3485 94.5267C96.9662 101.6 94.9367 115.033 90.2835 116.722C86.0065 118.273 84.5044 115.126 84.5044 115.126",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3317 85.2844C89.3317 85.2844 89.9082 75.4332 81.1232 69.1649C74.5866 64.5009 77.3551 38.1963 72.5677 34.5366C67.7802 30.8768 59.4619 34.2289 57.6455 45.3537C56.341 53.3432 63.0921 66.4511 60.9432 68.7418C58.7942 71.0326 40.267 68.0757 31.598 70.2883C23.7948 72.2799 19.0001 86.0523 33.006 89.198C47.0119 92.3436 57.3514 91.3732 58.3268 85.3282C59.5449 77.7784 47.4597 77.0558 40.2766 77.3206",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5597 86.0493C22.1018 88.621 20.336 95.076 26.0636 99.1372C34.7766 105.315 56.3745 106.465 59.3714 96.2185C60.3875 92.7446 58.854 90.5658 56.0561 88.8358",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5227 110.477C27.5227 110.477 23.1221 118.338 33.9792 121.48C44.8876 124.637 51.5251 122.409 53.6136 119.94C55.5907 117.603 55.2261 114.222 52.8752 112.683",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6778 99.8147C22.752 102.56 25.0848 109.126 28.1161 110.58C36.3107 114.511 50.5378 116.553 56.7688 109.79C58.9654 107.405 59.1354 102.177 56.6055 100.754",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9292 120.548C52.9292 120.548 60.1935 122.112 68.1166 121.513C77.4704 120.806 86.4764 114.237 87.9966 110.797",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8546 77.2589C87.8546 77.2589 89.5107 72.8904 93.1924 74.9621C96.9872 77.0974 97.7656 86.8109 97.3485 94.5267C96.9662 101.6 94.9367 115.033 90.2835 116.722C86.0065 118.273 84.5044 115.126 84.5044 115.126",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8608 80.3124C114.321 81.9871 146.684 78.9274 149.041 78.6658L144.426 115.821C144.426 115.821 108.035 113.896 91.7886 113.036",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_894_46040",
    x1: 142.645,
    y1: 74,
    x2: 107.984,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7656BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.260417,
    stopColor: "#7454B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410895,
    stopColor: "#6F51B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53341,
    stopColor: "#664AA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640871,
    stopColor: "#59418E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738494,
    stopColor: "#493574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828987,
    stopColor: "#352654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914032,
    stopColor: "#1D152E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992637,
    stopColor: "#020204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.a4874ba678462a02dbf7984b12f383f7.svg";
export { ForwardRef as ReactComponent };